import React, { useMemo } from 'react';
import {useTranslation} from "react-i18next";

type Props = {
    glbSrc: string;        // es: '/images/PalazzoDucale7_Anim.glb'
    usdzSrc: string;       // es: '/images/PalazzoDucale7_Anim.usdz' (not used, kept for compatibility)
    size?: 'small' | 'normal'; // dimensione del bottone AR
};

const isMobileUA = () =>
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const MobileAR: React.FC<Props> = ({
                                       glbSrc,
                                       usdzSrc,
                                       size = 'normal',
                                   }) => {
    const mobile = useMemo(isMobileUA, []);
    const { t }: any = useTranslation();

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);

    // Get absolute URL
    const getAbsoluteUrl = (path: string) => {
        if (path.startsWith('http')) return path;
        return `${window.location.origin}${path}`;
    };

    const handleClick = (e: React.MouseEvent) => {
        if (isAndroid && glbSrc) {
            e.preventDefault();
            // Android: Use Scene Viewer (Google ARCore) with GLB
            const absoluteGlbUrl = getAbsoluteUrl(glbSrc);
            const intent = `intent://arvr.google.com/scene-viewer/1.0?file=${encodeURIComponent(
                absoluteGlbUrl
            )}&mode=ar_preferred#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;end;`;
            window.location.href = intent;
            return;
        }

        if (!isIOS && !isAndroid) {
            e.preventDefault();
            alert('AR non supportata su questo dispositivo/navigatore.');
        }
        // For iOS, let the native <a> tag handle the AR (no preventDefault)
    };

    if (!mobile) return null;

    // Define sizes based on size prop
    const buttonWidth = size === 'small' ? 'w-[37.5px]' : 'w-[75px]';
    const buttonHeight = size === 'small' ? 'h-[22.5px]' : 'h-[45px]';
    const iconMaxHeight = size === 'small' ? 'max-h-[22.5px]' : 'max-h-[45px]';

    // For iOS, use native <a> tag with rel="ar" to open Quick Look directly
    const ButtonComponent = isIOS ? 'a' : 'button';
    const iosProps = isIOS ? {
        rel: 'ar',
        href: getAbsoluteUrl(usdzSrc),
    } : {};

    return (
        <div className="flex items-center gap-2">
            {!window.location.href.includes('/ar') && (
                <ButtonComponent
                    className={`${buttonWidth} ${buttonHeight} cursor-pointer block`}
                    onClick={handleClick}
                    {...iosProps}
                >
                    <img src="/images/RA-icon.png" alt="RA icon" className={iconMaxHeight}/>
                </ButtonComponent>
            )}
            {window.location.href.includes('/ar') && (
                <ButtonComponent
                    className={`w-[100%] ${buttonHeight} flex flex-col items-center justify-center gap-[10px] cursor-pointer`}
                    onClick={handleClick}
                    {...iosProps}
                >
                    <img src="/images/RA-icon.png" alt="RA icon" className={iconMaxHeight}/>
                    <h4 className="text-white text-sm lg:text-base font-untitledSans mb-[30px] sm:mb-[10px] lg:mb-[30px] w-full text-center">
                        {t('vt.palazzo_ar_mobile_page_title')}
                    </h4>
                </ButtonComponent>
            )}
        </div>
    );
};

export default MobileAR;